import { render, staticRenderFns } from "./MenuOverlay.vue?vue&type=template&id=180f9952&scoped=true"
import script from "./MenuOverlay.vue?vue&type=script&lang=js"
export * from "./MenuOverlay.vue?vue&type=script&lang=js"
import style0 from "./MenuOverlay.vue?vue&type=style&index=0&id=180f9952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f9952",
  null
  
)

export default component.exports